var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMoneyLightbulbOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0853 12.697C22.9792 12.3968 22.8154 12.1238 22.6073 11.8913C22.1648 11.3968 21.5216 11.0856 20.8057 11.0856H18.9347C17.7431 11.0856 16.7771 12.0516 16.7771 13.2432C16.7771 14.2572 17.4831 15.1343 18.4736 15.351L21.3222 15.9742C22.4319 16.2169 23.2228 17.2003 23.2228 18.3362C23.2228 19.6711 22.1406 20.7542 20.8057 20.7542H19.1942C18.1418 20.7542 17.2465 20.0816 16.9146 19.1428",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11.0856V8.66846",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 23.1713V20.7542",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.877 15.2408C30.8903 13.2993 30.3839 11.3896 29.41 9.70986C28.4361 8.03019 27.0303 6.64181 25.3387 5.68885C23.6471 4.73589 21.7312 4.2531 19.79 4.2906C17.8488 4.3281 15.9529 4.88453 14.2994 5.90211C12.6458 6.91968 11.2948 8.36134 10.3865 10.0774C9.47821 11.7934 9.04581 13.7213 9.1342 15.6609C9.22258 17.6004 9.8285 19.481 10.8891 21.1073C11.9497 22.7336 13.4263 24.0464 15.1655 24.9094V28.5352C15.1655 28.8557 15.2928 29.1632 15.5195 29.3896C15.7462 29.6164 16.0536 29.7437 16.3741 29.7437H23.6255C23.946 29.7437 24.2535 29.6164 24.4801 29.3896C24.7068 29.1632 24.8341 28.8557 24.8341 28.5352V24.9094C26.6408 24.0192 28.1635 22.6428 29.2311 20.9348C30.2985 19.2268 30.8685 17.2549 30.877 15.2408Z",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1655 35.7114H24.8341",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMoneyLightbulbOutline);
export default __webpack_public_path__ + "static/media/icon_money_lightbulb_outline.aac379f280ea577afbea27be1ca6db21.svg";
export { ForwardRef as ReactComponent };